export default __webpack_public_path__ + "static/client4-b1d5521921fb9c03b277a2d707e1603b.jpg";